import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { DashboardDataProviderFactory } from '../factory/DashboardDataProviderFactory';
import { DashboardBaseDataProvider } from '../dataProvider/DashboardBaseDataProvider';
import { GetCompaniesResponse, GetWidgetsForDashboardResponse } from '@nirvana/shared/dtos/types/dashboards/gz-console';
import {
  GetExecutiveSummaryPdfRequest,
  GetExecutiveSummaryPdfResponse,
} from '@nirvana/shared/dtos/types/dashboards/common';
import { TimeRange } from '@nirvana/shared/dtos/types/shared/time';

export class DashboardRepository extends BaseWebComponentRepository {
  public dataProviderFactory: DashboardDataProviderFactory;
  public dataProvider: DashboardBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new DashboardDataProviderFactory(),
    });
  }

  async setTimeRange(params: { dashboardId: string; timeRange: TimeRange }): Promise<{} | undefined> {
    return await this.dataProvider.setTimeRange(params);
  }

  async setTargets(params: { dashboardId: string; targets: Array<string> }): Promise<{} | undefined> {
    return await this.dataProvider.setTargets(params);
  }

  async getWidgetsForDashboard(params: { dashboardId: string }): Promise<GetWidgetsForDashboardResponse | undefined> {
    return await this.dataProvider.getWidgetsForDashboard(params);
  }

  async getCompanies(params: { companyName: string }): Promise<GetCompaniesResponse | undefined> {
    return await this.dataProvider.getCompanies(params);
  }

  async getExecutiveSummaryPdf(params: GetExecutiveSummaryPdfRequest): Promise<GetExecutiveSummaryPdfResponse> {
    return await this.dataProvider.getExecutiveSummaryPdf(params);
  }
}
